import React, {useEffect, useState} from 'react';
import './AIKefu.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLightbulb, faPlay, faRocket, faUserFriends, faVideo} from "@fortawesome/free-solid-svg-icons";
import ApiService from "../../api/ApiService";

const AIKefu = () => {
  const apiService = new ApiService();

  // 检测是否为手机端会员页面，如果是则不显示固定图标
  const isMobilePackagePage = false;

  // 添加直播相关状态
  const [isHoveringLive, setIsHoveringLive] = useState(false);
  const [showLiveImage, setShowLiveImage] = useState(true);
  const [showLiveOverlay, setShowLiveOverlay] = useState(false);
  const [liveQrCode, setLiveQrCode] = useState('');
  const [liveLoading, setLiveLoading] = useState(true);

  // 添加海报相关状态
  const [isHoveringJoin, setIsHoveringJoin] = useState(false);
  const [showJoinImage, setShowJoinImage] = useState(true);
  const [showJoinOverlay, setShowJoinOverlay] = useState(false);
  const [joinQrCode, setJoinQrCode] = useState('');
  const [joinLoading, setJoinLoading] = useState(true);

  // 在组件加载时获取图片链接
  useEffect(() => {
    // 获取直播预约二维码
    fetchBannerImage('online_video');

    // 获取加入我们图片
    fetchBannerImage('aboutUs');
  }, []);

  // 获取图片的方法
  const fetchBannerImage = (activityType) => {
      // 设置默认图片
      if (activityType === 'online_video') {
        setLiveQrCode('https://video-translate-web.oss-cn-beijing.aliyuncs.com/image/yunying.png');
        setLiveLoading(false);
      } else if (activityType === 'aboutUs') {
        setJoinQrCode('/images/join_us.png');
        setJoinLoading(false);
      }
  };

  const handleKefuClick = () => {
    // 使用window.open打开新标签页
    window.open('https://www.coze.cn/s/pSeptjkgA94/', '_blank');
  };

  // 直播相关处理函数
  const handleLiveMouseEnter = () => {
    setIsHoveringLive(true);
  };

  const handleLiveMouseLeave = () => {
    setIsHoveringLive(false);
  };

  const handleLiveClick = () => {
    setIsHoveringLive(false);
    setShowLiveOverlay(true);
  };

  const handleCloseLive = (e) => {
    e.stopPropagation();
    setShowLiveImage(false);
  };

  const handleCloseLiveOverlay = () => {
    setShowLiveOverlay(false);
  };

  // 加入我们的处理函数
  const handleJoinMouseEnter = () => {
    setIsHoveringJoin(true);
  };

  const handleJoinMouseLeave = () => {
    setIsHoveringJoin(false);
  };

  const handleJoinClick = () => {
    setIsHoveringJoin(false);
    setShowJoinOverlay(true);
  };

  const handleCloseJoin = (e) => {
    e.stopPropagation();
    setShowJoinImage(false);
  };

  const handleCloseJoinOverlay = () => {
    setShowJoinOverlay(false);
  };

  return (
    <div>
{/*      /!* 直播容器 *!/*/}
{/*      {!isMobilePackagePage && showLiveImage && (*/}
{/*        <div className="live-container">*/}
{/*          <div*/}
{/*            className={`live-element ${isHoveringLive ? 'live-expanded' : ''}`}*/}
{/*            onMouseEnter={handleLiveMouseEnter}*/}
{/*            onMouseLeave={handleLiveMouseLeave}*/}
{/*            onClick={handleLiveClick}*/}
{/*          >*/}
{/*            {isHoveringLive ? (*/}
{/*              <div className="live-expanded-content">*/}
{/*                <div className="live-header">*/}
{/*                  <FontAwesomeIcon icon={faVideo} className="live-pulse-icon" />*/}
{/*                  <span>沸推AIGC官方直播</span>*/}
{/*                </div>*/}
{/*                <div className="live-content">*/}
{/*                  <div className="live-text-container">*/}
{/*                    <h3>AI智能体掌握速成</h3>*/}
{/*                    <ul className="live-features">*/}
{/*                      <li>*/}
{/*                        <FontAwesomeIcon icon={faLightbulb} /> 成为AI领域领先者*/}
{/*                      </li>*/}
{/*                      <li>*/}
{/*                        <FontAwesomeIcon icon={faRocket} /> 快速掌握AI智能体*/}
{/*                      </li>*/}
{/*                    </ul>*/}
{/*                  </div>*/}
{/*                  <div className="live-cta">*/}
{/*                    <img*/}
{/*                      src="/images/vip/vip_pay_method_wechat.svg*/}
{/*"*/}
{/*                      alt="微信"*/}
{/*                      className="wechat-icon"*/}
{/*                    />*/}
{/*                    微信扫码立即关注，不容错过！*/}
{/*                  </div>*/}
{/*                </div>*/}
{/*                <div className="live-qrcode">*/}
{/*                  {liveLoading ? (*/}
{/*                    <div className="loading-spinner-live"></div>*/}
{/*                  ) : (*/}
{/*                    <img*/}
{/*                      src={liveQrCode}*/}
{/*                      alt="扫码观看直播"*/}
{/*                      className="live-qrcode-image"*/}
{/*                    />*/}
{/*                  )}*/}
{/*                </div>*/}
{/*              </div>*/}
{/*            ) : (*/}
{/*              <div className="live-icon">*/}
{/*                <FontAwesomeIcon icon={faVideo} />*/}
{/*                <span className="live-text">官方直播</span>*/}
{/*              </div>*/}
{/*            )}*/}
{/*          </div>*/}
{/*        </div>*/}
{/*      )}*/}

{/*      /!* 直播遮罩层 *!/*/}
{/*      {showLiveOverlay && (*/}
{/*        <div className="live-overlay" onClick={handleCloseLiveOverlay}>*/}
{/*          <div*/}
{/*            className="live-overlay-content"*/}
{/*            onClick={(e) => e.stopPropagation()}*/}
{/*          >*/}
{/*            <div className="live-overlay-header">*/}
{/*              <h2>沸推AIGC官方直播</h2>*/}
{/*              <p>*/}
{/*                <img*/}
{/*                  src="/images/vip/vip_pay_method_wechat.svg*/}
{/*"*/}
{/*                  alt="微信"*/}
{/*                  className="wechat-icon"*/}
{/*                />*/}
{/*                微信扫码观看，探索AI无限可能*/}
{/*              </p>*/}
{/*            </div>*/}
{/*            {liveLoading ? (*/}
{/*              <div className="loading-spinner-live large"></div>*/}
{/*            ) : (*/}
{/*              <img*/}
{/*                src={liveQrCode}*/}
{/*                alt="官方直播二维码"*/}
{/*                className="live-overlay-image"*/}
{/*              />*/}
{/*            )}*/}
{/*            <div className="live-overlay-description">*/}
{/*              <h3>为什么要观看我们的直播？</h3>*/}
{/*              <ul>*/}
{/*                <li>*/}
{/*                  <FontAwesomeIcon icon={faLightbulb} /> 学习前沿AI技术与应用*/}
{/*                </li>*/}
{/*                <li>*/}
{/*                  <FontAwesomeIcon icon={faRocket} /> 掌握AI智能体构建方法*/}
{/*                </li>*/}
{/*                <li>*/}
{/*                  <FontAwesomeIcon icon={faPlay} /> 实时互动，专家答疑*/}
{/*                </li>*/}
{/*              </ul>*/}
{/*            </div>*/}
{/*            <div className="live-overlay-cta">*/}
{/*              <img*/}
{/*                src="/images/vip/vip_pay_method_wechat.svg"*/}
{/*                alt="微信"*/}
{/*                className="wechat-icon"*/}
{/*              />*/}
{/*              立即扫码，开启AI新时代！*/}
{/*            </div>*/}
{/*            <button*/}
{/*              className="live-overlay-close"*/}
{/*              onClick={handleCloseLiveOverlay}*/}
{/*              aria-label="关闭"*/}
{/*            >*/}
{/*              ×*/}
{/*            </button>*/}
{/*          </div>*/}
{/*        </div>*/}
{/*      )}*/}

      {/* 加入社区容器 */}
      {!isMobilePackagePage && showJoinImage && (
        <div className="join-container">
          <div
            className={`join-element ${isHoveringJoin ? 'join-expanded' : ''}`}
            onMouseEnter={handleJoinMouseEnter}
            onMouseLeave={handleJoinMouseLeave}
            onClick={handleJoinClick}
          >
            {isHoveringJoin ? (
              <div className="join-expanded-content">
                {joinLoading ? (
                  <div className="loading-spinner-join"></div>
                ) : (
                  <img
                    src={joinQrCode}
                    alt="加入社群"
                    className="join-image"
                  />
                )}
              </div>
            ) : (
              <div className="join-icon">
                <FontAwesomeIcon icon={faUserFriends} size={'lg'} />
                <span className="join-text">加入社群</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 加入社区遮罩层 */}
      {showJoinOverlay && (
        <div className="join-overlay" onClick={handleCloseJoinOverlay}>
          <div
            className="join-overlay-content"
            onClick={(e) => e.stopPropagation()}
          >
            {joinLoading ? (
              <div className="loading-spinner large"></div>
            ) : (
              <img
                src={joinQrCode}
                alt="加入我们"
                className="join-overlay-image"
              />
            )}
            <button
              className="join-overlay-close"
              onClick={handleCloseJoinOverlay}
              aria-label="关闭"
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIKefu;